import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommodityViewComponent } from './commodity-view/commodity-view.component';
import { CommodityFormComponent } from './commodity-form/commodity-form.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommodityRoutingModule } from './commodity-routing-module';



@NgModule({
  declarations: [
    CommodityViewComponent,
    CommodityFormComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommodityRoutingModule
  ]
})
export class CommodityModule { }
